// tslint:disable-next-line:no-var-requires
require('ui-common/polyfills/customEvent');

import 'usertiming'; // polyfill performance.now
import 'formdata-polyfill'; // polyfill FormData
import * as ReactDOM from 'react-dom';
import 'login-stylesheets/global';
import routeConfiguration from './routeConfig';
import './index.scss';
import 'shared-react/assets/blend-icons.css';

ReactDOM.render(routeConfiguration, document.getElementById('root'));
